import { pickBy } from 'lodash'

import axiosInstance from 'api/axiosInstance'
import {
    type AnalyticsContentMessagesResponse,
    type AnalyticsContentResponse,
    type AnalyticsContentStoriesResponse,
    type ContentAnalytics,
    type ReportsAnalytics,
    type SalesAnalytics
} from 'types/api/analytic'

export const getSalesAnalytics = async ({
    dateFrom,
    dateTo,
    categoryId,
    chart
}: SalesAnalytics) => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: '/api/user/analytic/sales',
            params: {
                date_from: dateFrom,
                date_to: dateTo,
                category: categoryId,
                chart
            }
        })

        return data?.data
    } catch (error) {
        console.error('Error:', { error })
    }
}
export const getContentFeedAnalytics = async ({
    categoryId,
    filter,
    pageParam,
    sort
}: ContentAnalytics) => {
    try {
        const paramObj = {
            category: categoryId,
            filter_by: filter,
            page: pageParam,
            per_page: 15,
            ...sort
        }
        const filteredParamObj = pickBy(paramObj, value => value !== '')

        const { data } = await axiosInstance<AnalyticsContentResponse>({
            method: 'GET',
            url: '/api/user/analytic/content/feed',
            params: filteredParamObj
        })

        return {
            data: data?.data,
            nextCursor:
                data.meta.current_page < data.meta.last_page
                    ? data.meta.current_page + 1
                    : undefined
        }
    } catch (error) {
        console.error('Error:', { error })
    }
}
export const getContentPremiumAnalytics = async ({
    categoryId,
    filter,
    pageParam,
    sort
}: ContentAnalytics) => {
    try {
        const paramObj = {
            category: categoryId,
            filter_by: filter,
            page: pageParam,
            per_page: 15,
            ...sort
        }
        const filteredParamObj = pickBy(paramObj, value => value !== '')

        const { data } = await axiosInstance<AnalyticsContentResponse>({
            method: 'GET',
            url: '/api/user/analytic/content/premium',
            params: filteredParamObj
        })

        return {
            data: data?.data,
            nextCursor:
                data.meta.current_page < data.meta.last_page
                    ? data.meta.current_page + 1
                    : undefined
        }
    } catch (error) {
        console.error('Error:', { error })
    }
}
export const getContentMessagesAnalytics = async ({
    categoryId,
    filter,
    pageParam,
    sort
}: ContentAnalytics) => {
    try {
        const paramObj = {
            category: categoryId,
            filter_by: filter,
            page: pageParam,
            per_page: 15,
            ...sort
        }
        const filteredParamObj = pickBy(paramObj, value => value !== '')

        const { data } = await axiosInstance<AnalyticsContentMessagesResponse>({
            method: 'GET',
            url: '/api/user/analytic/content/messages',
            params: filteredParamObj
        })

        return {
            data: data?.data,
            nextCursor:
                data.meta.current_page < data.meta.last_page
                    ? data.meta.current_page + 1
                    : undefined
        }
    } catch (error) {
        console.error('Error:', { error })
    }
}
export const getContentStoriesAnalytics = async ({
    categoryId,
    filter,
    pageParam,
    sort
}: ContentAnalytics) => {
    try {
        const paramObj = {
            category: categoryId,
            filter_by: filter,
            page: pageParam,
            per_page: 15,
            ...sort
        }
        const filteredParamObj = pickBy(paramObj, value => value !== '')

        const { data } = await axiosInstance<AnalyticsContentStoriesResponse>({
            method: 'GET',
            url: '/api/user/analytic/content/stories',
            params: filteredParamObj
        })

        return {
            data: data?.data,
            nextCursor:
                data.meta.current_page < data.meta.last_page
                    ? data.meta.current_page + 1
                    : undefined
        }
    } catch (error) {
        console.error('Error:', { error })
    }
}

export const getReportsAnalytics = async <TChart>({
    tab,
    filter,
    dateFrom,
    dateTo,
    categoryId,
    chart
}: ReportsAnalytics<TChart>) => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: '/api/user/analytic/reports',
            params: {
                tab,
                filter,
                date_from: dateFrom,
                date_to: dateTo,
                category: categoryId,
                chart
            }
        })
        return data
    } catch (error) {
        console.error('Error:', error)
    }
}
